<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <SearchGrid>
        <el-form-item label="市场名称">
          <el-select v-model="marketId" clearable placeholder="请选择">
            <el-option v-for="(item, index) in $key.common.market" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账申请单号">
          <el-input v-model="applyCode" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="auditStatus" clearable placeholder="请选择">
            <el-option v-for="(item, index) in $key.myAccount.auditStatus" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker
            clearable
            v-model="startApplyTime"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker
            clearable
            v-model="endApplyTime"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
        </SearchGrid>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <el-table ref="zTable" :data="tableData">
      <el-table-column prop="marketName" label="市场名称" align="center" width="80"></el-table-column>
      <el-table-column prop="applyCode" label="转账申请单号" align="center"></el-table-column>
      <el-table-column prop="payerExAccountNo" label="付款单号" align="center"></el-table-column>
      <el-table-column prop="receiverExAccountNo" label="收款账号" align="center"></el-table-column>
      <el-table-column prop="receiverBaseAccountName" label="收款账户名" align="center"></el-table-column>
      <el-table-column prop="" label="金额（元）" align="center" width="80">
        <template slot-scope="scope">
          <span>
            {{scope.row.applyAmount | thousandMark}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="applyTime" label="申请时间" align="center"></el-table-column>
      <el-table-column prop="" label="审核状态" :formatter='toExamineStatus' align="center" width="80"></el-table-column>
      <el-table-column label="操作" align="center" width="80">
        <template v-slot="scope">
          <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout='total, prev, pager, next'
      :current-page.sync="currentPage"
      :total='total'
      @current-change="changePage"
      background>
    </el-pagination>
    <transfer-detail v-if="showDetail" :detailData="detailData" @done="handleClose"></transfer-detail>
  </div>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/util'
import transferDetail from './transfer-detail'
export default {
  name: 'transfer',
  components: {
    transferDetail
  },
  data () {
    return {
      // 市场状态
      marketId: '',
      // 审核状态
      auditStatus: '',
      // 转账申请日期
      startApplyTime: '',
      endApplyTime: '',
      // 转账申请单号
      applyCode: '',
      // 详情页
      showDetail: false,
      // 列表信息
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 10
    }
  },

  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 查询
    handleSearch () {
      this.fetchList(1)
    },
    // 重置
    handleReset () {
      this.marketId = ''
      this.auditStatus = ''
      this.tradeStatus = ''
      this.payerSubsidiaryAccountNo = ''
      this.receiverSubsidiaryAccountNo = ''
      this.startApplyTime = ''
      this.endApplyTime = ''
      this.applyCode = ''
      this.fetchList(1)
    },
    // 获取列表数据
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        marketId: this.marketId,
        auditStatus: this.auditStatus,
        startApplyTime: formatTime(this, this.startApplyTime),
        endApplyTime: formatTime(this, this.endApplyTime, 1),
        applyCode: this.applyCode,
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }

      let res = await api.myAccount.zbManageList(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    // 详情
    async toDetail (row) {
      let param = {
        id: row.id
      }
      this.detailData = (await api.myAccount.zbTransferDetail(param)).data
      this.showDetail = true
    },
    // 对方附属账户
    receiverSubsidiaryAccount (row) {
      return row.receiverSubsidiaryAccountNo.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
    },
    // 转出附属账户
    payerSubsidiaryAccount (row) {
      return row.payerSubsidiaryAccountNo.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
    },
    // 审核状态
    toExamineStatus (row) {
      if (row.auditStatus === '10') {
        return '待审核'
      } else if (row.auditStatus === '20') {
        return '审核通过'
      } else if (row.auditStatus === '30') {
        return '审核驳回'
      } else {
        return '/'
      }
    },
    // 交易状态
    transactionStatus (row) {
      if (row.tradeStatus === '10') {
        return '待支付'
      } else if (row.tradeStatus === '20') {
        return '支付中'
      } else if (row.tradeStatus === '30') {
        return '全部支付'
      } else if (row.tradeStatus === '40') {
        return '支付失败'
      } else {
        return '/'
      }
    },
    // 关闭弹窗
    handleClose () {
      this.showDetail = false
    },
    // 分页
    changePage (page) {
      this.fetchList(page)
    },
  }
}
</script>

<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
</style>
